import { render, staticRenderFns } from "./staffManage.vue?vue&type=template&id=4b303351&scoped=true&"
import script from "./staffManage.vue?vue&type=script&lang=js&"
export * from "./staffManage.vue?vue&type=script&lang=js&"
import style0 from "./staffManage.vue?vue&type=style&index=0&id=4b303351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b303351",
  null
  
)

export default component.exports